import { Avatar, Button, Grid, Paper, Typography, TextField, InputAdornment } from "@mui/material";
import React, { useEffect, useState } from "react";
import { isMobile } from "react-device-detect";
import styled from "styled-components";
import ComboBox from "../../../components/ComboBox";
import { usePallet } from "../../../contexts/PalletContext";
import RemoveRedEyeIcon from '@mui/icons-material/RemoveRedEye';
import IconLabelButtons from '../../../components/ButtonIconSalvar';
import { IListInfo } from '../../../models/IListInfo';
import EmptyError from '../../../components/EmptyError';
import PaginationSaveState from '../../../components/PaginationSaveState';
import { useNavigate } from "react-router-dom";
import TemaCorporativoCard from "../../temas_corporativos/_components/Grupo/TemaCorporativoCard";
import ListFilter, { IFilterData } from "../../../components/filter/ListFilter";
import TCService from "../../../services/TCService";
import ButtonIconSalvar from "../../../components/ButtonIconSalvar";
import ParlamentarMenuFiltroTipoComissao from "../../../components/ParlamentarMenuFiltroTipoComissao";
import FilterQuantity from "../../../components/filter/FilterQuantity";
import { Visibility } from "@material-ui/icons";
import PersonAddIcon from '@mui/icons-material/PersonAdd';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import UsuarioService from "../../../services/UsuarioService";
import GerUsuariosMenuFiltroAtivoInativo from "./GerUsuariosMenuFiltroAtivoInativo";
import EditIcon from '@mui/icons-material/Edit';
import GerUsuariosCadastro from "./GerUsuariosCadastro";
import GerDepartamentosCadastro from "./GerDepartamentosCadastro";
import GerUsuariosEdicaoLista from "./GerUsuariosEdicaoLista";
import ImageLoaderList from "../../../components/ImageLoaderList";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faSlidersH } from "@fortawesome/free-solid-svg-icons";
import ProposicaoListFilterItens from "../../proposicao/_components/filtro/ProposicaoListFilterItens";
import { arraysEquals } from "../../../utils/utils";
import GerUsuariosListFilterItens from "./GerUsuariosListFilterItens";
import { formatDate } from "../../../utils/dateUtils";
import ComboBoxBusca from "../../../components/ComboBoxBusca";
import SearchIcon from '@mui/icons-material/Search';
import useStyles from "../../../components/layout/Styles";




//## StyledCompenents
const FilterArea = styled(Paper)`
  width: 100%;
  /* height: 55px; */
  margin-top: 16px;
  margin-bottom: 10px;
  padding: 16px 16px 30px 16px;
  display: flex;
  flex-wrap: wrap;
  align-items: center;
  background-color: #ffff;
  border-radius: 0px 0px 0px 0px; 

  .filterTitle {
    display: none;
  }
`;

const ContainerHead = styled(Grid)`
 margin-bottom: 10px;
 margin-left: 0px;

 .MuiOutlinedInput-root { 
   background: #F9F9F9 !important;
   border: 0px !important;
 }
 fieldset {
   border-color: #F9F9F9 !important;
 }
`;

const ContainerFilter = styled(Grid)`
 /* width: 10%; */
 width: 100%;
 margin-bottom: 5px;
`;


const FilterButton = styled(Button)`
	font-family: Montserrat;
	font-style: normal;
	font-weight: 600;
	text-transform: capitalize;
	color: #FFFFFF;
	border: 0;
	font-size: 14px;
	line-height: 17px;	
	border-radius: 6px;
	padding: 10px;

	height: 100%;
  background: rgba(75, 17, 150, 0.9);
	:first-child {
		margin-right: 10px;
	}
  &:hover {
    background-color:  rgba(75, 17, 150, 0.9);
    color: #FFFFFF;
   
   }
`;

const ContainerBody = styled(Grid)`
 justify-content: ${isMobile ? "center" : "space-between"};
 flex-direction: column;
 padding: 20px 40px;
`;

const PaperContent = styled(Paper)`
 color: ${(props) => props.pallet.textColorQuaternary};
 font-size: ${(props) => props.pallet.fontSize.titleWidgets};
 font-family: ${(props) => props.pallet.fontFamily.general};
 font-weight: 600;
 padding-top: 10%;
 padding-bottom: 10%;
 width: 100%;
 text-align: center;
 background-color: #ffff;
`;

const ContainerFooter = styled(Grid)`
 margin-top: 40px;
 margin-bottom: 10px;
 padding-bottom: 50px;
 justify-content: center;

 button.Mui-selected {
   background-color: #4B1196;
   color: #F2F2F2;

   &:hover {
    background-color: #4B1196;
    color: #F2F2F2;
    opacity: 0.7;
   }
 }
`;


export default function GerUsuariosTabsHistAtividades(props: { id_user: number, index: number, activeTab: number, onChange: () => void }) {
  //export default function TCTemasCorporativosGrupoList() {
  const { pallet } = usePallet();
  const navigate = useNavigate();

  //## Paginação
  const [infoList, setInfoList] = useState<IListInfo>({
    pageIndex: 1,
    pageSize: 8,
    pageItens: 0,
    totalItens: 0,
    totalPages: 0,
  });

  const [currentPageSize, setCurrentPageSize] = useState<number>(50);
  const [currentPage, setCurrentPage] = useState<number>(1);
  const [filter, setFilter] = useState([{ key: "situacao", label: "Todos", value: "T" }]);
  //const [filtro, setFiltro] = useState<string>('T');
  const [currentFilter, setCurrentFilter] = useState<IFilterData[]>([]);

  const filterName = 'TemasRelacionadosListCurrentPage';
  // const filterItens = [
  //   { key: "visualizacao", label: "Tudo", value: "T" },
  //   { key: "visualizacao", label: "Relacionados", value: "R" },
  //   { key: "visualizacao", label: "Não Relacionados", value: "NR" },
  // ]

  //## Dados
  const [lista, setLista] = useState([]);
  const [listaDescricao, setListaDescricao] = useState<string[]>([]);
  const [busca, setBusca] = useState<IFilterData[]>();
  const [descricaoParcial, setDescricaoParcial] = useState<any>();
  const [anchorEl, setAnchorEl] = React.useState<null | HTMLElement>(null);
  const [open, setOpen] = React.useState();
  const [openFilter, setOpenFilter] = React.useState<boolean>(false);





  const descFiltro = (value: string) => {
    switch (value) {
      case "T":
        return "[ Todos ]";
      case "I":
        return "[ Inativo ]";
      case "A":
        return "[ Ativo ]";
    }
  }

  const [opfiltro, setOpfiltro] = useState(descFiltro("T"));

  const handleToggleFilter = () => setOpenFilter(!openFilter);

  useEffect(() => {
    if (currentPage > 0) loadUserList();
  }, [currentPage, currentPageSize]);

  const changeFiltrarStatus = () => {
    if (currentPage > 0) loadUserList();
  };

  const loadUserList = () => {
    //const filter = currentFilter ? currentFilter.map(item => { return { key: item.key, label: item.label, value: item.value } }) : [];    
    // const f = filter ? filter.map(item => { return { key: item.key, label: item.label, value: item.value } }) : [{ key: "situacao", label: "Todos", value: "T" }];


    //==>const f = [{ key: 'tipo', value: filtro }]

    // if (descricaoParcial && descricaoParcial.trim() !== "") {
    //   f.push({ key: 'descricaoParcial', label: 'Descrição', value: descricaoParcial });
    //==>setNome(() => undefined)
    // }
    console.log("OLHA A DESC",localStorage.getItem('descricaoP'));

    if (!localStorage.getItem('descricaoP')) {
      UsuarioService.GetLogUsuarioGer(currentPageSize, currentPage, JSON.stringify(currentFilter ? currentFilter : [{ key: "situacao", label: "Todos", value: "T" }])) // force break --JSON.stringify(currentFilter)
        .then(async (res) => {
          if (res) {
            setLista(res.data.data);
            setInfoList(res.listInfo);
          }
        });

    } else  {
      UsuarioService.GetLogUsuarioGer(currentPageSize, currentPage, JSON.stringify([{ key: 'descricaoP', label: "Descrição", value: localStorage.getItem('descricaoP') }]))
        .then(async res => {
          if (res) {
            setLista(res.data.data);
            setInfoList(res.listInfo);
          }
        });

    }

  };

  const pressBuscaUsuario = (event: any) => {
    if (event?.key === 'Enter') {
      
      if (event.target.value) {
        console.log('press Busca if',event?.target?.value);
         localStorage.setItem('descricaoP', event?.target?.value);
        UsuarioService.GetLogUsuarioGer(currentPageSize, currentPage, JSON.stringify([...currentFilter, { key: 'descricaoP', label: "Descrição", value: event?.target?.value }]))
        .then(async res => {
          if (res) {
            setLista(res.data.data);
            setInfoList(res.listInfo);            }
          });

      }
       else {
       localStorage.removeItem('descricaoP')
        UsuarioService.GetLogUsuarioGer(currentPageSize, currentPage, '') // force break --JSON.stringify(currentFilter)
          .then(async (res) => {
            if (res) {
              setLista(res.data.data);
              setInfoList(res.listInfo);
            }
          });

      }
    }
  }

  //## Funções'
  // const handleOnChangeItensPerPageSize = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   setCurrentPageSize(Number(event.target.value));
  // };

  // const handleOnChangeFilter = (event: React.ChangeEvent<HTMLInputElement>) => {
  //   const selectedFilter: IFilterData = JSON.parse(event.target.value);
  //   //setFilter(selectedFilter);
  //   setCurrentFilter([...currentFilter.filter(x => x.key !== selectedFilter.key), selectedFilter]);
  // };

  const handleOnChangeFilter = (data: IFilterData[]) => {
    if (!arraysEquals(currentFilter, data)) setCurrentFilter(() => [...data]);
  };


  const [value, setValue] = React.useState('');
  const classes = useStyles();
  console.log("Cade",descricaoParcial)
  return (
    <>
      <ContainerHead container>
        {/* <Grid container>
        </Grid>
        <Grid
          style={{
            width: isMobile ? "90%" : "100%",
          }}
        /> */}

        <ContainerFilter>
          <FilterArea>
            <Grid style={{
              width: `${isMobile ? "60%" : "78%"}`, paddingLeft: `${isMobile ? "10px" : "28px"}`
            }}>
              <Grid container item xs={6}>
                <Grid style={{ marginRight: "8px" }}>
                  <Grid style={{
                    color: `${pallet.textColorTertiary}`,
                    fontWeight: pallet.general.weight_600
                  }}>
                    {infoList?.totalItens}
                  </Grid>
                </Grid>

                <Grid>
                  <Grid item style={{
                    fontFamily: `${pallet.fontFamily.general}`,
                    fontSize: "14px",
                    fontWeight: pallet.general.weight_600,
                    paddingTop: "2px"
                  }}>
                    {infoList?.totalItens > 1 ? "REGISTROS" : "REGISTRO"} <span style={{
                      color: `${pallet.textColorTertiary}`,
                      fontWeight: pallet.general.weight_600
                    }}> </span>
                  </Grid>
                </Grid>
              </Grid>


            </Grid>

            <Grid style={{ width: `${isMobile ? "35%" : "22%"}`, display: "flex", justifyContent: "flex-end", border: "1px", borderColor: "green" }}>
              <FilterButton
                startIcon={<FontAwesomeIcon icon={faSlidersH} />}
                onClick={handleToggleFilter}
                backgroundColor={pallet.backgroundColorTertiary}
              >
                Filtrar
              </FilterButton>
            </Grid>
            <ListFilter
              filtrarAction={changeFiltrarStatus}
              name={"UsuarioListCurrentFilter"}
              filter={currentFilter}
              // defaultFilter={defaultFilter}
              open={openFilter}
              onToogle={handleToggleFilter}
              onChangeFilter={handleOnChangeFilter}
            >
              <GerUsuariosListFilterItens filter={currentFilter} onChangeFilter={handleOnChangeFilter} />
            </ListFilter>
          </FilterArea>
        </ContainerFilter>

        <Grid style={{ width: "100%", margin: "20px 40px" }}>
          {/* <ComboBoxBusca
            name="filtroBuscaLog"
            onChange={handleBuscaChange}
            placeholder="Buscar"
          /> */}


          <TextField
            // placeholder={`Digite${selectedInput === 'buscaGeral' ? ' + ENTER' : ' a proposição + ENTER'}`}
            placeholder={`Digite + ENTER`}
            fullWidth
            variant="outlined"
            defaultValue={value}
            onKeyPress={pressBuscaUsuario}
            style={{ width: isMobile ? '250px' : '400px', display: 'inline-block' }}
            InputProps={{
              classes: {
                notchedOutline: classes.notchedOutline
              },
              style: {
                fontFamily: `${pallet.general.fontFamily}`,
                fontSize: `${pallet.general.size14}`,
                fontWeight: pallet.general.weight_100,
                background: `${pallet.backgroundColorSecondary}`
              },
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon />
                </InputAdornment>
              ),
            }}
          />
        </Grid>
      </ContainerHead>
      <ContainerBody container style={{ marginTop: "20px" }}>

        <TableContainer component={Paper}>
          <Table sx={{ minWidth: 650 }} aria-label="simple table">
            <TableHead>
              <TableRow>
                <TableCell>DATA</TableCell>
                <TableCell align="left">HORA</TableCell>
                <TableCell align="left"></TableCell>
                <TableCell align="left">USUÁRIO</TableCell>
                <TableCell align="left">DEPARTAMENTO</TableCell>
                <TableCell align="left">TIPO</TableCell>
                <TableCell align="left">IP EXTERNO</TableCell>
                <TableCell align="left">ATIVIDADE</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {
                lista && lista.map((row, index) => (
                  <TableRow
                    key={index}
                    sx={{ '&:last-child td, &:last-child th': { border: 0 } }}
                  >
                    <TableCell align="left">{formatDate(new Date(row.log_date), "dd/MM/yyyy")}</TableCell>
                    <TableCell align="left">{formatDate(new Date(row.log_date), "HH:mm")}</TableCell>
                    <TableCell align="left">
                      <Grid style={{ marginLeft: `${isMobile ? "5px" : "20px"}` }}>
                        {/* <Avatar src={row.arquivo} /> */}
                        <ImageLoaderList
                          src={row.arquivo}
                          pallet={pallet}
                          canEdit={false}
                        />
                      </Grid>
                    </TableCell>
                    <TableCell component="th" scope="row">
                      {row.log_usernome}
                    </TableCell>
                    <TableCell align="left">{row?.log_departamentodesc.join('  |  ')}</TableCell>
                    <TableCell align="left">{row?.log_tipodesc}</TableCell>
                    <TableCell style={{ minWidth: "150px" }} align="left">{row?.ip_externo}</TableCell>
                    <TableCell align="left">{row?.log_descricao}</TableCell>
                  </TableRow>
                ))
              }
            </TableBody>
          </Table>
        </TableContainer>

        {lista && !lista.length && (
          <PaperContent pallet={pallet}>
            <EmptyError title="Ops! Nenhum resultado." description="Que tal refazer a busca?" />
          </PaperContent>
        )}
      </ContainerBody>
      <ContainerFooter container>
        <PaginationSaveState
          name={filterName}
          pages={infoList?.totalPages}
          page={currentPage}
          onChange={setCurrentPage}
        />
      </ContainerFooter>
    </>
  )
}